import { Image, Avatar, Popover, message, Select, Modal } from 'antd'
// import logo1 from 'assets/img/logo1.svg'
// import logo2 from 'assets/img/logo2.svg'
import './Header.scss'
import {
    ToggleIcon,
    LangEnIcon,
    LangZhIcon,
    NickNameIcon,
    TogeProjectIcon,
    IsNoFrIcon,
    IsFrIcon,
    NinePointsIcon,
    POMSIcon,
    FLAGIcon,
    // VTSIcon,
    CNPCIcon,
    DarkIcon,
    SelectIcon,
    SunIcon,
    SaturationIcon,
} from 'assets/icons'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
    getAuthInfoAction,
    getProjectBaseDataAction,
    getStreamerDataAction,
    getHomeListAction,
    changeProjectAction,
    LocationSlice,
    getMobilisationPlanDataAction,
} from 'redux/reducers'
import { useEffect, useState } from 'react'
import { useContextConsumer } from 'context/loginAuthProvider'
import classnames from 'classnames'
import { setStroage, getStroage, isBetweenSevenToSeven } from 'utils'
import { useNavigate } from 'react-router-dom'
import { persistor } from 'redux/store'
import i18n from 'i18next'
import { HeaderSlice } from 'redux/reducers'
import bgpImage from 'assets/img/BGP.png'
import bigScreen4K from 'assets/img/4K.png'
// import bigScreen1080p from 'assets/img/1080p.png'
import faviconImage from 'assets/img/stormGeo.png'
import weatherImage from 'assets/img/Weather.png'
import MegaShare from 'assets/img/MegaShare.png'
import { pomsLoginApi, getAuthLogoutApi } from 'api'

const Left = ({ isHome }) => {
    const [scrollTop, setScrollTop] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const outlineBorder = useSelector(state => state.HeaderSlice.outlineBorder)

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = document.scrollingElement.scrollTop
            if (scrollTop > 0) setScrollTop(true)
            if (scrollTop === 0) setScrollTop(false)
        } // 更新页面卷动值
        document.addEventListener('scroll', handleScroll) // 监听滚动事件
        return () => document.removeEventListener('scroll', handleScroll) // 取消多余事件
    }, [])
    const goHome = () => {
        navigate('/home')
        const widthBrowser = document.body.clientWidth
        if (widthBrowser < 960) dispatch(HeaderSlice.actions.changepOutlineBorder(!outlineBorder)) // 浏览器宽度小于960防止内嵌菜单缩放
    }

    return (
        <div className={`main-left-header ${isHome ? 'main-left-header-home' : ''} ${scrollTop ? 'scrolling' : ''}`}>
            {isHome ? <></> : <ToggleIcon />}
            <div className={outlineBorder ? 'imageLogoShrink' : 'imageLogo'}>
                <Image height={24} src={MegaShare} preview={false} className='logo1' onClick={() => goHome()} />
            </div>
        </div>
    )
}

/* 当前环境 */
const apiUrl = process.env.REACT_APP_SERVER

const Right = ({ isHome }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { logout } = useContextConsumer()
    const [scrollTop, setScrollTop] = useState(false)
    const [settingIconPopOpen, setSettingIconPopOpen] = useState(false)
    const [ThemeIconPopOpen, setThemeIconPopOpen] = useState(false)
    const [linksOpen, setLinksOpen] = useState(false)
    const language = getStroage('language')
    const themeColor = getStroage('themeColor')
    const userInfo = useSelector(state => state.HeaderSlice.userInfo)
    const projectName = userInfo?.user?.projectName
    const projectNameAlias = userInfo?.project?.projectNameAlias
    const projectId = userInfo?.user?.projectId
    const navigate = useNavigate()
    const [isFullScreen, setIsFullScreen] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const paginatedData = useSelector(state => state.HomeSlice.paginatedData)
    const outlineBorder = useSelector(state => state.HeaderSlice.outlineBorder)
    const { theme } = useContextConsumer() // 登录权鉴

    /* 获取项目列表 */
    const getPaginationData = (searchValues = {}) => {
        const result = { ...searchValues }
        Object.keys(searchValues).forEach(item => {
            if (result[item] === undefined) {
                result[item] = ''
            }
        })
        const params = {
            ...result,
            pageNum: 1,
            pageSize: 99999,
            orderByColumn: 'update_time',
            isAsc: false,
        }
        dispatch(getHomeListAction(params)) // 发送请求
    }

    /* 切换语言、主题 */
    const changLanguage = () => {
        // 刷新浏览器
        window.location.reload(false)
        const result = language === 'en'
        if (result) {
            i18n.changeLanguage('zh')
            setStroage('language', 'zh')
        } else {
            i18n.changeLanguage('en')
            setStroage('language', 'en')
        }
    }

    // const changTheme = e => theme(e.target.dataset.theme) // 改变主题
    const handleClick = async () => {
        const ticket = getStroage('ticket')
        if (ticket) {
            await getAuthLogoutApi(ticket)
        }
        window.location.reload(false)
        // dispatch(NavSlice.actions.addSelectedKeys(['/dataSource'])) // 重置路由首页
        await persistor.purge() // 清除 redux 持久存储内容
        // dispatch(LocationSlice.actions.clearLocation()) // 重置 location 狀態
        logout() // 退出登录，清除 token
    }

    /* 监听页面卷动信息 */
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = document.scrollingElement.scrollTop
            if (scrollTop > 0) setScrollTop(true)
            if (scrollTop === 0) setScrollTop(false)
        } // 更新页面卷动值
        document.addEventListener('scroll', handleScroll) // 监听滚动事件
        return () => {
            document.removeEventListener('scroll', handleScroll) // 取消多余事件
        }
    }, [])

    /* 获取用户信息 */
    useEffect(() => {
        // dispatch(getUserInfoAction()) // 获取用户相关信息
        dispatch(getAuthInfoAction()) // 获取用户权限信息
    }, [])

    /* 关闭用户设置弹窗 */
    useEffect(() => {
        getPaginationData()
        const handleFun = e => {
            let classname = e.target.className
            let result3 = false
            if (Object.prototype.toString.call(classname) === '[object SVGAnimatedString]') result3 = true
            if (!classname) classname = e?.target?.offsetParent?.className
            const result = classname?.match?.('avatarHeader')
            const result2 = classname?.match?.('ant-avatar-string')

            if (result || result2 || result3) return
            setSettingIconPopOpen(false)
            setLinksOpen(false)
        }
        window.addEventListener('click', handleFun)
        return () => window.removeEventListener('click', handleFun)
    }, [])

    /* 关闭人员导入弹窗 */
    useEffect(() => {
        const handleFun = e => {
            let classname = e.target.className
            let result5 = false
            if (Object.prototype.toString.call(classname) === '[object SVGAnimatedString]') result5 = true
            if (!classname) classname = e?.target?.offsetParent?.className
            const result = classname?.match?.('copyBtn')
            const result2 = classname?.match?.('ant-popover-open')
            const result3 = classname?.match?.('ant-btn-primary')
            const result4 = classname?.match?.('ant-btn')

            if (result || result2 || result3 || result4 || result5) return
            setThemeIconPopOpen(false)
        }
        window.addEventListener('click', handleFun)
        return () => window.removeEventListener('click', handleFun)
    }, [])

    /* 获取项目信息 */
    useEffect(() => {
        if (!projectId) return
        dispatch(getProjectBaseDataAction(projectId))
        dispatch(getMobilisationPlanDataAction(projectId)) // 获取 动迁计划 信息
        dispatch(getStreamerDataAction(projectId)) // 获取 Streamer信息
    }, [projectId, dispatch])

    /* 新用户选择项目 */
    useEffect(() => {
        if (!userInfo) return // 这行很重要，不能删！
        if (!projectName) navigate('/home')
    }, [projectName, userInfo])

    /* 监听键盘全屏事件 */
    useEffect(() => {
        const handleFun = e => {
            if (e.code === 'Esc' || e.code === 'F11') {
                if (!isFullScreen) setIsFullScreen(true)
            }
        }
        const handleFun2 = e => {
            function getFullScreen() {
                if (window.screenTop && window.screenY) {
                    return true
                } else {
                    return false
                }
            }
            if (!getFullScreen()) setIsFullScreen(false)
        }
        window.addEventListener('keydown', handleFun)
        window.addEventListener('resize', handleFun2)
        return () => {
            window.removeEventListener('keydown', handleFun)
            window.removeEventListener('resize', handleFun2)
        }
    }, [isFullScreen])

    const pomsLogin = async () => {
        const fineAPI = await (await pomsLoginApi()).data.data
        window.open(fineAPI, '_blank')
    }

    // 记忆主题颜色
    useEffect(() => {
        if (themeColor) return
        setStroage('themeColor', 'light')
    }, [])

    // 记忆主题颜色
    useEffect(() => {
        if (themeColor === 'light') {
            theme('blue')
        } else if (themeColor === 'dark') {
            theme('dark')
        } else {
            if (isBetweenSevenToSeven()) {
                // '现在是早上七点到晚上七点之间。'
                theme('blue')
            } else {
                // '现在不是早上七点到晚上七点之间。'
                theme('dark')
            }
        }
    }, [themeColor])

    let screenWidth = window.screen.width

    return (
        <div
            className={classnames('main-right-header', {
                scrolling: scrollTop, // 有卷动值，不在 home 页，加载类名
            })}
        >
            {/* 不要删除这个 div, 用来 flex 布局占位的 */}
            <div></div>
            <div className='top-setting'>
                {/* 展示当前项目名 */}
                <div className='currentProjectName'>
                    <Select
                        allowClear={false}
                        showSearch={true}
                        showArrow={false}
                        listHeight={350}
                        className='switchProjectList'
                        options={paginatedData?.data?.map(item => ({
                            label:
                                language === 'zh'
                                    ? item.projectNameAlias ?? item.projectName
                                    : item.projectName ?? item.projectNameAlias,
                            value:
                                item.id +
                                '&' +
                                (language === 'zh'
                                    ? item.projectNameAlias ?? item.projectName
                                    : item.projectName ?? item.projectNameAlias),
                        }))}
                        onChange={async value => {
                            await dispatch(changeProjectAction(value.split('&')[0])) // 发送请求，改变项目
                            await persistor.purge() // 清除 redux 持久存储内容
                            dispatch(LocationSlice.actions.clearLocation()) // 重置 location 狀態
                            const origin = window.location.origin
                            window.location.replace(origin + '?outlineBorder=' + outlineBorder) // 刷新网页，改变 url
                        }}
                        value={
                            projectId
                                ? language === 'zh'
                                    ? projectNameAlias ?? projectName
                                    : projectName ?? projectNameAlias
                                : t('header.tips1')
                        }
                    />

                    <TogeProjectIcon
                        onClick={() => {
                            if (projectName && isHome) {
                                navigate('/')
                            } else {
                                navigate('/home')
                            }
                        }}
                    />
                </div>

                {/* 切换主题 */}
                {screenWidth > 960 && (
                    <Popover
                        content={
                            <>
                                <div
                                    className='sunIcons'
                                    onClick={() => {
                                        setThemeIconPopOpen(false)
                                        setStroage('themeColor', 'light')
                                    }}
                                >
                                    <div className={themeColor !== 'light' ? 'sun' : 'sun active'}>
                                        <SunIcon className='SunIcon' />
                                        <p>{t('header.mode.light')}</p>
                                    </div>
                                </div>
                                <div
                                    className='darkIcons'
                                    onClick={() => {
                                        setThemeIconPopOpen(false)
                                        setStroage('themeColor', 'dark')
                                    }}
                                >
                                    <div className={themeColor !== 'dark' ? 'darks' : 'darks active'}>
                                        <DarkIcon className='SelectDarkIcon' />
                                        <p>{t('header.mode.dark')}</p>
                                    </div>
                                </div>
                                <div
                                    className='autoIcons'
                                    onClick={() => {
                                        setThemeIconPopOpen(false)
                                        setStroage('themeColor', 'auto')
                                    }}
                                >
                                    <div className={themeColor !== 'auto' ? 'auto' : 'auto active'}>
                                        <SaturationIcon className='SunIcon' />
                                        <p>{t('header.mode.auto')}</p>
                                    </div>
                                </div>
                            </>
                        }
                        trigger='click'
                        placement='bottomRight'
                        destroyTooltipOnHide={true}
                        getPopupContainer={() => document.getElementsByClassName('avatar')[0]}
                        visible={ThemeIconPopOpen}
                    >
                        <div className='dark' onClick={() => setThemeIconPopOpen(!ThemeIconPopOpen)}>
                            {themeColor === 'light' && <SunIcon className='lightIcon' />}
                            {themeColor === 'dark' && <DarkIcon className='DarkIcon' />}
                            {themeColor === 'auto' && <SaturationIcon className='autoIcon' />}
                            <SelectIcon className='SelectIcon' />
                        </div>
                    </Popover>
                )}

                {/* 切换语言 */}
                <div onClick={changLanguage} className='langIcon'>
                    {language === 'en' ? <LangEnIcon className='langEnIcon' /> : <LangZhIcon className='langZnIcon' />}
                </div>

                {/* 全屏按钮 */}
                {isFullScreen ? (
                    <IsNoFrIcon
                        className='themeIcon'
                        onClick={() => {
                            function cancelFullscreen() {
                                if (document.exitFullscreen) {
                                    document.exitFullscreen()
                                } else if (document.msExitFullscreen) {
                                    document.msExitFullscreen()
                                } else if (document.mozCancelFullScreen) {
                                    document.mozCancelFullScreen()
                                } else if (document.webkitExitFullscreen) {
                                    document.webkitExitFullscreen()
                                }
                            }
                            setIsFullScreen(false)
                            cancelFullscreen(document.documentElement)
                        }}
                    />
                ) : (
                    <IsFrIcon
                        className='themeIcon'
                        onClick={() => {
                            const fullscreen = element => {
                                if (document.mozFullScreenEnabled) {
                                    return message.warning('全屏模式被禁用')
                                }
                                let result = null
                                if (element.requestFullscreen) {
                                    result = element.requestFullscreen()
                                } else if (element.mozRequestFullScreen) {
                                    result = element.mozRequestFullScreen()
                                } else if (element.msRequestFullscreen) {
                                    result = element.msRequestFullscreen()
                                } else if (element.webkitRequestFullscreen) {
                                    result = element.webkitRequestFullScreen()
                                }
                                if (result) setIsFullScreen(true)
                                return result || message.warning('浏览器不支持全屏模式')
                            }
                            fullscreen(document.documentElement)
                        }}
                    />
                )}

                {/* 友情链接 */}
                <Popover
                    content={
                        <div className='links-content'>
                            <div className='top'>
                                {/* POMS 大屏 */}
                                <div
                                    className='links-item'
                                    // onClick={() => {
                                    //     setIsModalOpen(true)
                                    // }}
                                    onClick={pomsLogin}
                                >
                                    <POMSIcon className='icon' />
                                    <div className='name'>MegaInsight</div>
                                </div>
                                {/* FLAG */}
                                <div
                                    className='links-item'
                                    onClick={() => window.open('https://flagbgpo.com/', '_blank')}
                                >
                                    <FLAGIcon className='icon' />
                                    <div className='name'>FLAG</div>
                                </div>
                                {/* HiFleet */}
                                <div
                                    className='links-item'
                                    onClick={() => window.open('https://hifleet.com/', '_blank')}
                                >
                                    <img src={faviconImage} alt='' className='Favicon' />
                                    <div className='name'>HiFleet</div>
                                </div>
                                {/* StormGeo */}
                                <div
                                    className='links-item'
                                    onClick={() =>
                                        window.open('https://customers.stormgeo.com/portal/loadportal', '_blank')
                                    }
                                >
                                    <img src={weatherImage} alt='' className='Favicon' />
                                    <div className='name'>StormGeo</div>
                                </div>
                            </div>
                            <div className='down'>
                                {/* CNPC */}
                                <div
                                    className='links-item'
                                    onClick={() => window.open('http://www.cnpc.com.cn/en/', '_blank')}
                                >
                                    <CNPCIcon className='icon' />
                                    <div className='name'>CNPC</div>
                                </div>
                                {/* BGP */}
                                <div
                                    className='links-item BGP'
                                    onClick={() => window.open('http://www.bgp.com.cn/', '_blank')}
                                >
                                    <img src={bgpImage} alt='' className='BGPIcon' />
                                    <div className='name'>BGP</div>
                                </div>
                            </div>
                        </div>
                    }
                    trigger='click'
                    placement='bottomRight'
                    destroyTooltipOnHide={true}
                    getPopupContainer={() => document.getElementsByClassName('links')[0]}
                    visible={linksOpen}
                >
                    <NinePointsIcon
                        className={`links ${linksOpen && 'links-open'}`}
                        onClick={() => setLinksOpen(!linksOpen)}
                    />
                </Popover>

                <Modal
                    title={t('common.tips27')}
                    visible={isModalOpen}
                    onCancel={() => setIsModalOpen(false)}
                    footer={null}
                    wrapClassName='POMSModal'
                >
                    <div
                        className='bigScreen1080p'
                        onClick={() =>
                            window.open(
                                'http://1.92.84.125:8080/tempo-bi-runtime/publish/show/0e0a05c353884a279f930db5316696a9/90f078da381c40d9bb868a9dad490944',
                                '_blank'
                            )
                        }
                    >
                        <img src={bigScreen4K} alt='' />
                        <div>3840 * 1120</div>
                    </div>
                    <div
                        className='bigScreen4K'
                        onClick={() =>
                            window.open(
                                'http://1.92.84.125:8080/tempo-bi-runtime/publish/show/0e0a05c353884a279f930db5316696a9/b301bbd606c9463d9b40a34bc871c463',
                                '_blank'
                            )
                        }
                    >
                        <img src={bigScreen4K} alt='' />
                        <div>3840 * 2160</div>
                    </div>
                </Modal>

                {/* 切换主题 */}
                {/* <Popover
                    content={
                        <div className='themeIcon-Dot'>{t('common.tips14')}</div>
                        // <div onClick={changTheme} className='themeIcon-Dot'>
                        //     <span className='theme-blue' data-theme='blue'></span>
                        //     <span className='theme-red' data-theme='red'></span>
                        // </div>
                    }
                    trigger='click'
                    placement='bottomRight'
                    destroyTooltipOnHide={true}
                    getPopupContainer={() => document.getElementsByClassName('top-setting')[0]}
                >
                    <ThemeIcon className='themeIcon' />
                </Popover> */}

                {/* 用户头像 */}
                <Popover
                    content={
                        <div className='settingIcon' onClick={() => setSettingIconPopOpen(false)}>
                            <div className='userName'>
                                <NickNameIcon className='nickNameIcon' />
                                <p>{userInfo?.user?.nickName}</p>
                            </div>
                            <div className='profile' onClick={() => navigate('/profile')}>
                                {t('header.enterBtn')}
                            </div>
                            <div className='feedBack'>
                                <a href='mailto:klseis@cnpc.com.cn'>{t('header.feedBack')}</a>
                            </div>
                            <div className='line'></div>
                            <p onClick={handleClick} className='logoutBtn'>
                                {t('header.logout')}
                            </p>
                        </div>
                    }
                    trigger='click'
                    placement='bottomRight'
                    destroyTooltipOnHide={true}
                    getPopupContainer={() => document.getElementsByClassName('avatar')[0]}
                    visible={settingIconPopOpen}
                >
                    <Avatar
                        size={32}
                        src={userInfo && apiUrl + userInfo?.user?.avatar}
                        className='avatar avatarHeader'
                        shape='circle'
                        onClick={() => setSettingIconPopOpen(!settingIconPopOpen)}
                    >
                        {userInfo ? userInfo?.user?.nickName?.slice(0, 1) : ''}
                    </Avatar>
                </Popover>
            </div>
        </div>
    )
}

export const Header = { Left, Right }
